<template>
  <section class="hero is-fullheight l-authentification has-background-white">
    <div class="hero-body is-align-items-flex-start">
      <div class="card is-w334p is-borderless is-shadowless resetPassword">
        <!--<div class="has-text-centered is-padding-top has-background-white">
          <router-link :to="{name: 'Login'}" class="is-inline-flex">
            <img :src="$configs.LOGO_LOGIN" width="100" :alt="$configs.COMPANY">
          </router-link>
        </div>-->
        <div class="has-text-centered is-margin-top-auto">
          <router-link :to="{name: 'Login'}">
            <img
              src="/img/vadimm/cadenas-illustration.svg"
              class="image is-margin-left-auto is-margin-right-auto"
              width="200"
              alt="Vadimm">
          </router-link>
        </div>
        <header class="card-header is-shadowless is-margin-top">
          <h1
            class="card-header-title is-size-2 is-padding-left-small"
            v-html="title"></h1>
        </header>
        <section class="card-content">
          <div>
            <p v-if="text">
              {{ text }}
            </p>
            <form @submit.prevent.stop="submit">
              <transition
                enter-active-class="animated fadeIn fasterx2"
                leave-active-class="animated fadeOut fasterx2"
                mode="out-in">
                <div
                  v-if="step === STEPS.EMAIL_FORM"
                  :key="STEPS.EMAIL_FORM">
                  <p class="is-size-6">
                    Vous avez oublié votre mot de passe ?<br>
                    Saisissez votre adresse e-mail et nous vous enverrons un lien de création de nouveau mot de passe.
                  </p>
                  <div class="is-margin-top-small">
                    <v-input
                      id="resetEmail"
                      name="resetEmail"
                      @input="val => email = val"
                      :model="email"
                      label="Email *"
                      placeholder="VOTRE EMAIL"
                      :input-type="'email'"
                      v-validate="'required|email'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Email">
                    </v-input>
                  </div>
                </div>
                <div
                  v-if="step === STEPS.RESET_METHODS"
                  :key="STEPS.RESET_METHODS">
                  <p class="is-size-6">
                    Nous avons trouvé les informations suivantes relatives à votre compte.
                  </p>
                  <div class="field is-margin-top-small">
                    <input
                      id="email-method"
                      v-model="resetMethod"
                      name="method"
                      type="radio"
                      value="email"
                      class="is-checkradio">
                    <label for="email-method">
                      Envoyer un lien par email à <b>{{ email }}</b>
                    </label>
                  </div>
                  <div
                    v-for="(method, idx) in resetMethods"
                    class="field"
                    :key="idx">
                    <input
                      :id="'phone-' + idx"
                      v-model="resetMethod"
                      name="method"
                      type="radio"
                      :value="method.value"
                      class="is-checkradio">
                    <label :for="'phone-' + idx">
                      Envoyer un code par SMS à mon numéro de téléphone se terminant par
                      <b>{{ method }}</b>
                    </label>
                  </div>
                </div>
                <div
                  v-if="step === STEPS.TOKEN_FORM"
                  :key="STEPS.TOKEN_FORM">
                  <p class="is-size-6">
                    Nous avons envoyé un code par SMS sur votre numéro de téléphone. <br>
                    Une fois le code reçu, entrez le ci-dessous pour réinitialiser votre mot de passe.
                  </p>
                  <v-input
                    :name="'email'"
                    :classes-input="'is-fullwidth'"
                    @input="val =>token = val"
                    :model="token"
                    :placeholder="'CODE'"
                    v-validate="'required|min:6'"
                    autocomplete="one-time-code"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Code"
                    class="is-margin-top-small">
                    <!--<template slot="label">
                      <r-label :label="'Code *'" :value="email" :forId="'email'" :isRequired="false"></r-label>
                    </template>-->
                  </v-input>

                  <p><a @click.prevent.stop="resendToken">Je n'ai pas reçu le SMS ? Envoyez un email</a></p>
                </div>
                <div
                  class=""
                  v-if="step === STEPS.PASSWORD_FORM"
                  :key="STEPS.PASSWORD_FORM">
                  <div class="field is-margin-top-small">
                    <v-input-password
                      :name="'password'"
                      :classes-input="'is-fullwidth'"
                      @input="password = $event"
                      :model="password"
                      :display-password.sync="displayPassword1"
                      :placeholder="'VOTRE MOT DE PASSE'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Mot de passe"
                      data-type-cy="input"
                      data-value-cy="login_password"></v-input-password>
                  </div>

                  <div class="field">
                    <v-input-password
                      :name="'confirmPassword'"
                      :classes-input="'is-fullwidth'"
                      @input="confirmPassword = $event"
                      :model="confirmPassword"
                      :display-password.sync="displayPassword2"
                      :placeholder="'CONFIRMER VOTRE MOT DE PASSE'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Confirmation du mot de passe"
                      data-type-cy="input"
                      data-value-cy="login_password"></v-input-password>
                  </div>

                  <password-validator
                    :password="password"
                    :confirm-password="confirmPassword"
                    :min-length="12"
                    :require-lower-case="false"
                    :show-confirmation="true"
                    @validation-changed="passwordIsValid = $event">
                  </password-validator>
                </div>
                <div
                  v-if="step === STEPS.MAIL_SENT"
                  :key="STEPS.MAIL_SENT">
                  <div class="">
                    <p class="is-size-6">
                      Les instructions de réinitialisation de votre mot de passe ont été
                      envoyées à <b>{{ email }}</b>.
                    </p>
                    <p class="is-size-6 is-margin-top-xxsmall">
                      Vous recevrez cet e-mail dans les cinq minutes. Vérifier votre dossier
                      de courrier
                      indésirable.
                    </p>
                  </div>
                </div>
                <div
                  v-if="step === STEPS.PASSWORD_SET"
                  :key="STEPS.PASSWORD_SET">
                  <div class="is-size-6">
                    Mot de passe actualisé, vous pouvez vous connecter.
                  </div>
                </div>
                <div
                  v-if="step === STEPS.ERROR_MESSAGE"
                  :key="STEPS.ERROR_MESSAGE">
                  <div class="is-size-6">
                    Impossible de modifier votre mot de passe. Veuillez contactez un administrateur.
                  </div>
                </div>
              </transition>
              <transition
                enter-active-class="animated fadeIn fasterx2"
                leave-active-class="animated fadeOu fasterx2"
                mode="out-in">
                <div
                  class="control is-margin-top"
                  v-if="step !== STEPS.MAIL_SENT && step !== STEPS.PASSWORD_SET"
                  key="btnValid">
                  <button
                    class="button is-login is-fullwidth is-radiusless"
                    @click.prevent.stop="submit"
                    :disabled="!canSubmit">
                    <span
                      class="is-uppercase is-size-6 has-text-weight-medium">Valider</span>
                  </button>
                </div>
                <!--<div class="control is-margin-top"
                     v-else key="btnBackLogin"
                >
                  <router-link :to="{name: 'Login'}" class="button is-light is-fullwidth is-radiusless"><span
                    class="is-uppercase is-size-6 has-text-weight-medium">Retour page login</span></router-link>
                </div>-->
              </transition>
              <div
                v-if="step === STEPS.PASSWORD_SET"
                class="control is-margin-top-xsmall"
                key="btnBackLogin">
                <a
                  @click="onTokenSent"
                  class="button is-primary is-fullwidth is-radiusless">
                  <span
                    class="is-uppercase is-size-6 has-text-weight-medium">Se connecter</span>
                </a>
              </div>
            </form>
          </div>
        </section>

        <div class="resetPassword-footer is-padding-left-small is-padding-right-small is-align-items-flex-end">
          <div class="columns is-gapless is-vcentered is-hidden-mobile ">
            <div class="column">
              <img
                src="/img/vadimm/vadimm-logo--multicolor.svg"
                width="24"
                alt="" />
            </div>
            <div class="column">
              <p class="has-text-right has-text-grey-light is-size-7">
                <small>Vadimm V. {{ $configs.APPVERSION }}</small>
              </p>
            </div>
          </div>

          <div class="columns is-gapless is-vcentered is-mobile is-hidden-tablet">
            <div class="column is-narrow">
              <img
                src="/img/vadimm/logo-vadimm--x2.png"
                class="image"
                width="66"
                alt="">
            </div>
            <div class="column is-padding-left-small">
              <p class="has-text-grey is-size-7">
                <small>V. {{ $configs.APPVERSION }}</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Error, DefaultValues } from '@/mixins'
// import { bus, EVENTS } from '../../bus.js'

const STEPS = Object.freeze({
  EMAIL_FORM: 'EMAIL_FORM',
  TOKEN_FORM: 'TOKEN_FORM',
  RESET_METHODS: 'RESET_METHODS',
  PASSWORD_FORM: 'PASSWORD_FORM',
  MAIL_SENT: 'MAIL_SENT',
  PASSWORD_SET: 'PASSWORD_SET',
  ERROR_MESSAGE: 'ERROR_MESSAGE'
})

export default {
  name: 'ResetPassword',
  components: {
    PasswordValidator: () => import('@/components/common/PasswordValidator')
  },
  mixins: [Error, DefaultValues],
  data () {
    return {
      step: STEPS.EMAIL_FORM,
      STEPS: STEPS,
      email: null,
      resetMethods: [],
      resetMethod: null,
      title: 'Réinitialisation<br>du mot de passe',
      text: null,
      token: null,
      password: null,
      confirmPassword: null,
      passwordIsValid: false,
      displayPassword1: false,
      displayPassword2: false
    }
  },
  computed: {
    samePassword () {
      return this.password && this.password === this.confirmPassword
    },
    canSubmit () {
      if (this.step === STEPS.EMAIL_FORM) {
        return this.email !== null && this.errors.any() === false
      } else if (this.step === STEPS.RESET_METHODS) {
        return this.resetMethod !== null
      } else if (this.step === STEPS.TOKEN_FORM) {
        return this.token !== null && this.errors.any() === false
      } else if (this.step === STEPS.PASSWORD_FORM) {
        return this.errors.any() === false && this.passwordIsValid
      }
      return false
    }
  },
  created () {
    if (this.$route.query.token && this.$route.query.email) {
      this.email = this.$route.query.email
      this.token = this.$route.query.token
      this.step = STEPS.PASSWORD_FORM
    }
    if (this.$route.query.mode && this.$route.query.mode === 'invitation') {
      this.title = 'Activation<br>compte utilisateur'
      this.text = 'Pour finaliser la création de votre compte utilisateur, merci de choisir un mot de passe de connexion.\nVotre mot de passe est confidentiel et sécurisé.'

      let testToken = async () => {
        try {
          await this.$api.checkToken(this.token)
        } catch (err) {
          // console.log(err)
          this.handleError(err)
        }
      }
      testToken()
    }
  },
  methods: {
    resendToken () {
      this.sendResetPasswordEmail()
      this.step = STEPS.MAIL_SENT
    },
    async loadResetMethods () {
      try {
        let result = await this.$api.passwordRecoverMethods(this.email)
        this.title = 'Comment voulez-vous réinitialiser votre mot de passe&nbsp;?'
        this.text = null
        if (!result.data.phone) {
          this.sendResetPasswordEmail()
        } else {
          this.resetMethods.push(result.data.phone)
          this.step = STEPS.RESET_METHODS
        }
      } catch (err) {
        console.log(err)
        this.handleError(err)
      }
    },
    async sendResetPasswordEmail () {
      try {
        await this.$api.passwordRecover(this.email)
        this.step = STEPS.MAIL_SENT
        this.title = 'Instructions envoyées !'
        this.$toasted.global.success('Un email vous a été envoyé.')
      } catch (err) {
        if (err.response.status === 429) {
          this.$toasted.global.danger('Trop de tentatives veuillez réessayer plus tard !')
        } else {
          this.handleError(err)
          this.$toasted.global.danger('Email non reconnu, veuillez vérifier votre saisie.')
        }
      }
    },
    async checkToken () {
      // TOKEN_EXPIRED: 'Lien expiré'
      try {
        await this.$api.checkToken(this.token)
        this.title = 'Saisissez votre<br>nouveau mot de passe'
        this.text = null
        this.step = STEPS.PASSWORD_FORM
      } catch (err) {
        this.$toasted.global.danger('Ce Code ne semble pas correct.')
      }
    },
    async sendResetTokenSms () {
      try {
        await this.$api.passwordRecover(this.email, 'sms')
        this.title = 'Saisissez le<br>code reçu par sms'
        this.text = null
        this.$toasted.global.success('Un sms vous a été envoyé.')
      } catch (err) {
        console.log(err)
        this.handleError(err)
      }
    },
    async resetPassword () {
      if (!this.samePassword) {
        this.$toasted.global.danger('Les deux mots de passe ne sont pas identiques.')
        return
      }
      try {
        this.text = ''
        await this.$api.passwordReset(this.token, this.password)
        this.step = STEPS.PASSWORD_SET

        if (this.getMobileOperatingSystem() === 'Android') {
          window.location = this.mobileLinks.appHomePageGoogleLink
        } else if (this.getMobileOperatingSystem() === 'iOS') {
          window.location = this.mobileLinks.appHomePageIosLink
        }
        this.$toasted.global.success('Mot de passe mis à jour avec succès.')
      } catch (err) {
        console.log(err)
        this.handleError(err)
      }
    },
    /**
     * Get mobile operating system based on user agent.
     * @returns {string|null}
     */
    getMobileOperatingSystem () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return null
      }
      if (/android/i.test(userAgent)) {
        return 'Android'
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }
      return null
    },
    submit () {
      if (this.step === STEPS.EMAIL_FORM) {
        this.errors.clear()
        this.loadResetMethods()
      } else if (this.step === STEPS.RESET_METHODS) {
        if (this.resetMethod === 'email') {
          this.sendResetPasswordEmail()
          // this.step = STEPS.MAIL_SENT
          // this.title = 'Instructions envoyées !'
          this.text = null
        } else {
          this.sendResetTokenSms()
          this.errors.clear()
          this.step = STEPS.TOKEN_FORM
        }
      } else if (this.step === STEPS.TOKEN_FORM) {
        this.errors.clear()
        this.checkToken()
      } else if (this.step === STEPS.PASSWORD_FORM) {
        this.resetPassword()
      }
    },
    onTokenSent () {
      if (localStorage.getItem('referrer')) {
        window.location = localStorage.getItem('referrer')
      } else {
        this.$router.push({ name: 'Login', query: { email: this.$route.query.email } })
      }
    }
  }
}
</script>
